/**
 *Created by jmmartinez on 30/09/20

 * */

export const ACCION_NUEVO = 'NUEVO';
export const ACCION_MODIFICAR = 'MODIFICAR';
export const ACCION_CLONAR = 'CLONAR';